

























import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';

import { TranslateResult } from 'vue-i18n';
import { PostMembersResetPasswordRequest } from 'ncp-api-supporter';

type IssuanceType = 'EMAIL' | 'SMS' | 'ALL';
interface IssuanceTypeOption {
  name: string,
  data: { id: string, value: string, dispaly: TranslateResult }[]
}

@Component({
  components: {
    PageTitle,
    RadioElement,
    DateCalendar
  }
})
export default class TemporaryPassword extends Vue {
  private readonly targetMember = sessionStorage.getItem('memberName');

  private readonly issuanceNoticeTypes: IssuanceTypeOption = {
    name: 'issuanceNoticeType',
    data: [
      {
        id: 'email',
        value: 'EMAIL',
        dispaly: this.$t('MEMBER_POPUP_DATA_DISPLAY_E_MAIL')
      },
      {
        id: 'sms',
        value: 'SMS',
        dispaly: 'SMS '
      },
      {
        id: 'sendAll',
        value: 'ALL',
        dispaly: this.$t('MEMBER_POPUP_DATA_DISPLAY_SEND_ALL')
      }
    ]
  }
  private issuanceNoticeType: IssuanceType = 'EMAIL';

  private async issueTemporaryPassword() {
    const memberNo = Number(this.$route.query.memberNumber);
    const mallNo = Number(this.$route.query.mallNo);

    const request: PostMembersResetPasswordRequest = {
      data: {
        mallNo,
        memberNo,
        notificationType: this.issuanceNoticeType
        }};
    await this.$api.postMembersResetPassword(request);
    alert(this.$t('MEMBER_TEMPORARY_PASSWORD_ALERT_ISSUANCE_COMPLETE'));
    window.close()
  }

  private cancel() {
    window.close();
  }

}
